<template>
  <div>
    <div
      v-for="(classiferItems, classifierTopic) in classifierList"
      :key="classifierTopic"
    >
      <div class="infoBlock">
        <div v-if="classiferItems.length > 1">
          <InfoBlockPackageList
            :label="classifierTopic"
            :data-automation="'package-' + classifierTopic.toLowerCase().replace(' ', '-')"
            :value="classiferItems"
          />
        </div>
        <div
          v-else
          :data-automation="'package-' + classifierTopic.toLowerCase().replace(' ', '-')"
        >
          <div class="label">
            {{ classifierTopic }}
          </div>
          {{ classiferItems[0].name }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import InfoBlockPackageList from '../InfoBlockPackageList'

export default {
  name: 'ClassifiersList',
  components: {
    InfoBlockPackageList,
  },
  props: {
    classifiers: {
      type: Array,
      required: false,
      default: function () { return [] },
    },
  },
  computed: {
    classifierList: function () {
      if (!this.classifiers || this.classifiers === undefined || this.classifiers.length === 0) {
        return {}
      }

      const classifierList = {}

      this.classifiers.forEach(function (classifier) {
        const key = classifier.split('::')[0].trim()
        const entry = classifier.split('::').slice(1).join('::').trim()

        if (key === 'License') {
          return
        }

        if (classifierList[key] === undefined) {
          classifierList[key] = [{ name: entry }]
        } else {
          classifierList[key].push({ name: entry })
        }
      })

      return classifierList
    },
  },
}

</script>
